import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Grid, Button } from '@material-ui/core'
import OnEvent from 'react-onevent'
import qs from 'query-string'

// utils

import { isValidString } from '../utils/string'

// action

import { recoverPassword } from '../actions/auth'
import { openErrorMessage } from '../actions/message'

// local files

import ModifiedTextInput from '../components/common/ModifiedTextInput'
import ContainerWithTitle from '../containers/HOC/ContainerWithTitle'
import SideCoverHOC from './SideCover'

class Recover extends PureComponent {
  state = {
    password: '',
    confirmPassword: '',
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  onSubmit = () => {
    const { password, confirmPassword } = this.state

    if (!isValidString(password)) {
      return this.props.dispatch(openErrorMessage(`Password can't be blank`))
    }

    if (password !== confirmPassword) {
      return this.props.dispatch(openErrorMessage(`Passwords doesn't match`))
    }

    const searchParams = window.location.search
    const queryParams = qs.parse(searchParams)

    this.props
      .dispatch(
        recoverPassword({
          password,
          resetCode: queryParams.code,
        }),
      )
      .then(() => {
        this.props.history.push('/login')
      })
  }

  render() {
    const { password = '', confirmPassword = '' } = this.state

    return (
      <OnEvent enter={this.onSubmit}>
        <Grid className="rightBlockLogin" item xs={11} sm={7} md={11} lg={7}>
          <div>
            <h1 className="big-header slim-heading">Reset</h1>
          </div>
          <ModifiedTextInput
            id="password"
            placeholder="New Password"
            margin="normal"
            className="margin-top-medium"
            onChange={this.onChange}
            value={password}
            name="password"
            type="password"
          />
          <ModifiedTextInput
            id="confirmPassword"
            placeholder="Confirm Password"
            margin="normal"
            className="margin-top-medium"
            onChange={this.onChange}
            value={confirmPassword}
            name="confirmPassword"
            type="password"
          />
          <div className="vertical-middle margin-top-small">
            <Link className="black-link" to="/">
              Back to login
            </Link>
          </div>
          <div className="margin-top-medium">
            <Button onClick={this.onSubmit} className="float-right" id="login-button">
              Reset
            </Button>
          </div>
        </Grid>
      </OnEvent>
    )
  }
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
}))(SideCoverHOC(ContainerWithTitle(Recover, 'Reset Password')))



// WEBPACK FOOTER //
// ./src/containers/Recover.js